/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'


const displayPageCount = 5;

const Pagination = ({ totalCount, setPage, pageNumber, pageSize, externalPaging, changePageValues, enableScrolling }) => {
    const [pages, setPages] = React.useState([])

    React.useEffect(() => {
        createPaging()
    }, [totalCount, pageSize])
    const createPaging = () => {
        if (totalCount !== undefined) {
            const _pages = totalCount < parseInt(pageSize) ? 1 : Math.ceil(totalCount / parseInt(pageSize));
            let tempPages = []
            for (let i = 0; i < _pages; i++) {
                const element = i + 1;
                tempPages.push({ page: element, selected: element === pageNumber })

            }
            setPages([...tempPages])
        }
    }
    const changePageSize = (pageSize) => {
        changePageValues({ pageSize: pageSize })
    }
    const selectPage = (page) => {
        if (!enableScrolling) {
            changePageValues({ pageNumber: page })
        } else {
            setPage({ pageNumber: page })
        }
    }

    const displayPageConditions = (page) => {
        if ((((pageNumber + displayPageCount) > page.page) && page.page >= pageNumber) ||
            (((pageNumber + displayPageCount) > page.page) && pages.length - page.page < displayPageCount)) {
            return true
        }
        return false;
    }
    if (externalPaging) {
        return (
            <>
                {externalPaging({
                    pageNumber,
                    selectPage,
                    pages,
                    displayPageConditions,
                    changePageSize,
                    totalCount, pageSize,
                    setPage, enableScrolling
                })}
            </>
        )
    }

    return (
        <div className='pagging-container d-flex justify-content-center' >
            {pages.length > 1 && < div className='page-spn-context'>
                {pageNumber > 1 ?
                    <span className='prev-page-spn' onClick={() => selectPage(pageNumber - 1)} ><ArrowLeft /></span> :
                    <span className='disabled prev-page-spn' ><ArrowLeft /></span>}
                {pages.map((page, idx) => {
                    if (displayPageConditions(page)) {
                        return (<span className={page.page === pageNumber ? 'selected px-2' : 'px-2'}
                            key={idx}
                            onClick={() => selectPage(page.page)} >{page.page}</span>)
                    }
                })}
                {pageNumber < pages.length ?
                    <span className='next-page-spn' onClick={() => selectPage(pageNumber + 1)} > <ArrowRight /></span> :
                    <span className='disabled next-page-spn'> <ArrowRight /></span>
                }

            </div>}
        </div >
    )
}

export default Pagination



const ArrowLeft = ({ width = 24, height = 24, fill, styles }) => {
    return (
        <svg style={{ ...styles, width, height, verticalAlign: "middle" }} viewBox="0 0 24 24">
            <path d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" />
        </svg>
    );
};

const ArrowRight = ({ width = 24, height = 24, fill, styles }) => {
    return (
        <svg style={{ ...styles, width, height, verticalAlign: "middle" }} viewBox="0 0 24 24">
            <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
        </svg>
    );
};